import debugFactory from "debug";

const debuggers = {};

export default {
	/** @override */
	teamingPackage: "",
	computed: {
		debugKey() {
			const { uid, } = this.$;
			const { name, teamingPackage = "", } = this.$options;
			const [ packageName, subPackageName = "components", ] = teamingPackage.split( "." );
			return `${ packageName || "?" }:${ subPackageName }:${ name }[${ uid }]`;
		},
	},
	methods: {
		debug( ...args ) {
			const { debugKey, } = this;
			if ( !debuggers[ debugKey ] ) {
				debuggers[ debugKey ] = debugFactory( `teaming:${ debugKey }` );
			}
			debuggers[ debugKey ]( ...args );
		},
	},
	beforeUnmount() {
		const { debugKey, } = this;
		debuggers[ debugKey ] = null;
		delete debuggers[ debugKey ];
	},
};
